module.exports = __webpack_public_path__ + "static/img/10.40ce6d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/10.jpg
// module id = 405
// module chunks = 1